import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLazyQuery } from '@apollo/client';
import { loadAuthFromStorage } from '../store/slices/authSlice';
import { loadMateFromStorage, setCurrentUser, clearCurrentUser } from '../store/slices/mateSlice';
import { ME } from '../graphql/queries';

const ReduxInitializer = ({ children }) => {
  const dispatch = useDispatch();

  const isAuthError = (apolloError) => {
    const messages = (apolloError?.graphQLErrors || [])
      .map((e) => (e?.message || '').toLowerCase())
      .filter(Boolean);
    const networkStatus = apolloError?.networkError?.statusCode || apolloError?.networkError?.status;

    // Typiske auth-fejl (både DK/EN) + evt. 401
    const authLike =
      messages.some((m) =>
        m.includes('ikke autoriseret') ||
        m.includes('unauthorized') ||
        m.includes('not authorized') ||
        m.includes('jwt') ||
        m.includes('token')
      ) || networkStatus === 401;

    return authLike;
  };

  const [validateUser] = useLazyQuery(ME, {
    onCompleted: (data) => {
      if (data.me) {
        dispatch(setCurrentUser(data.me));
      } else {
        // Hvis brugeren ikke findes i databasen, log ud
        dispatch(clearCurrentUser());
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    },
    onError: (error) => {
      console.error('Fejl ved validering af bruger:', error);
      // Log kun ud hvis det reelt er en auth-fejl.
      // Ved netværks-/serverfejl skal vi ikke smide en ellers gyldig token væk.
      if (isAuthError(error)) {
        dispatch(clearCurrentUser());
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    },
    fetchPolicy: 'network-only' // Altid hent fra server, ikke cache
  });

  useEffect(() => {
    // Load authentication state from localStorage
    dispatch(loadAuthFromStorage());
    dispatch(loadMateFromStorage());
    
    // IKKE load game state fra localStorage - dette skal kun komme fra database
    // dispatch(loadGameFromStorage());
    
    // Valider bruger mod databasen hvis vi har en token
    const token = localStorage.getItem('token');
    if (token) {
      validateUser();
    }
  }, [dispatch, validateUser]);

  return children;
};

export default ReduxInitializer;
